import React from 'react';

import CoreByline from '@spp/ui-byline';
import { config } from '../../config';

const Byline = (props) => {
    const { ariaLabels: { byline: { listTitle = 'Skrevet av' } = {} } = {} } = config;

    return <CoreByline {...props} listTitle={listTitle} listFormat={{ separator: '' }} />;
};

export default Byline;



/** WEBPACK FOOTER **
 ** ./src/local-components/article/Byline.js
 **/